/* gk-job-count.js
 *
 * Menyegarkan jumlah lowongan tayang di storefront dari satu file kecil di
 * Supabase Storage. Sebelum ini angkanya ditulis tangan di dua tempat
 * (proof bar landing dan kartu statistik Tentang Kami) dan sudah terlanjur
 * basi: tertulis 248 padahal live-nya 282.
 *
 * Kenapa count.json, bukan jobs.json: jobs.json isinya seluruh lowongan,
 * hampir 100 KB. Dua halaman ini tidak butuh satu pun isi lowongan, cuma
 * jumlahnya. count.json sekitar 80 byte, dibangun edge function yang sama
 * pada saat yang sama, jadi angkanya tidak mungkin berbeda dari job board.
 *
 * Angka statis di Liquid TIDAK dihapus. Dia tetap terkirim di HTML, jadi
 * crawler dan pengunjung tanpa JS tetap melihat angka yang masuk akal.
 * Skrip ini cuma menimpanya kalau berhasil.
 */
(function () {
  'use strict';

  var URL_COUNT =
    'https://sftrxlriosixrryqcibx.supabase.co/storage/v1/object/public/job-feed/count.json';

  var target = document.querySelectorAll('[data-gk-live-count]');
  if (!target.length || typeof fetch !== 'function') return;

  // Format ribuan id-ID: 1.234. Angka lowongan masih ratusan, tapi kalau
  // suatu saat tembus seribu, tampilannya tetap benar tanpa perlu disentuh.
  function format(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  fetch(URL_COUNT, { cache: 'no-store' })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (data) {
      var n = data && data.count;
      // Angka nol atau negatif hampir pasti build yang gagal separuh jalan.
      // Lebih baik membiarkan angka statis daripada memajang "0 lowongan".
      if (typeof n !== 'number' || !isFinite(n) || n <= 0) return;

      for (var i = 0; i < target.length; i++) {
        // Yang diganti CUMA deretan angka pertama di dalam elemen, jadi kata
        // di sekelilingnya ("lowongan sponsorship aktif") tetap utuh dan
        // tidak perlu diduplikasi di sini.
        var el = target[i];
        var isi = el.textContent;
        var teks = el.getAttribute('data-gk-live-count') === 'rb' && n >= 1000
          ? String(Math.floor(n / 1000)) + 'rb+'
          : format(n);
        var baru = isi.replace(/\d[\d.]*(?:rb\+)?/, teks);
        if (baru !== isi) el.textContent = baru;
      }
    })
    .catch(function () {
      // Sengaja diam. Kegagalan menyegarkan angka hiasan tidak boleh
      // memunculkan error di console halaman yang lain-lainnya sehat.
    });
})();
